export const training = {
    route: 'Inteligentné učenie',
    selectDevice: 'Vyberte zariadenie',
    saveEvent: 'Uložiť udalosť',
    changeEvent: 'Zmeniť udalosť',
    addNew: 'Pridať nové...',
    saveSelected: 'Uložiť vybrané udalosti',
    l1unknown: 'L1 neznáme',
    l2unknown: 'L2 neznáme',
    l3unknown: 'L3 neznáme',
    l123unknown: '3-fázy neznáme',
    l1devices: 'L1 zariadenia',
    l2devices: 'L2 zariadenia',
    l3devices: 'L3 zariadenia',
    l123devices: '3-fázové zariadenia',
    unknownDevice: 'Neznáme zariadenie',
    deleted: 'Vymazané',
    filterDevice: 'Filter:',
    unknownDevices: 'Neznáme zariadenia',
    none: 'Žiadne',
    zoomSelection: 'Zväčšiť výber',
    clearSelection: 'Vymazať výber/zväčšenie',
    clearZoom: 'Vymazať zväčšenie',
    groupBy: 'Združiť podľa',
    groupByPhases: 'Fáz',
    groupByDevices: 'Zariadení',
    groupBy5Clusters: '5 Klastrov',
    groupBy10Clusters: '10 Klastrov',
    groupBy20Clusters: '20 Klastrov',
    unknown: 'Neznáme',
    others: 'Iné zariadenia',
    cluster: 'Skupina',
    smartTipsTitle: 'Ako používať inteligentné učenie?',
    smartTips: [
        { key: 0 , text: 'Tu nájdete všetky udalosti, ktoré sa udiali vo vašej domácnosti za posledných 30 dní. Ak chcete vidieť konkrétne časové obdobie, posuňte posúvacie značky v hornej časti grafu.'},
        { key: 1 , text: 'V predvolenom nastavení sú udalosti zoskupené podľa fázy, ale z výberového poľa v pravom hornom rohu môžete vybrať aj ďalšie možnosti, ako napríklad zoskupenie podľa zariadenia alebo rôzne veľkosti klastrov.'},
        { key: 2 , text: 'Pomocou kolieska myši alebo touchpadu môžete priblížiť udalosti a pretiahnutím grafu ich tiež posúvať. Ak sa chcete vrátiť do pôvodného výrezu, pomocou tlačidiel v pravom hornom rohu zrušte zväčšenie a/alebo výber.'},
        { key: 3 , text: 'Existujú dva typy udalostí, udalosti, ktoré sú už priradené zariadeniu (malé kruhy) a tie, ktoré nie sú známe (veľké kruhy).'},
        { key: 4 , text: 'Ak chcete zariadeniu priradiť neznáme udalosti, kliknite a vyberte ich a potom stlačte tlačidlo „Uložiť vybrané udalosti“. Tam môžete vytvoriť nové zariadenie pre vybrané udalosti alebo ich priradiť k existujúcemu zariadeniu.'}
    ],
    selectPeriod: 'Vyberte časový interval',
    last2min: '2 minút',
    last5min: '5 minút',
    last10min: '10 minút',
    last30min: '30 minút',
    last1hour: '1 hodina',
    last3hours: '3 hodiny',
    last6hours: '6 hodín',
    last12hours: '12 hodín',
    last24hours: '24 hodín',
    today: 'Dnes',
    yesterday: 'Včera',
    thisWeek: 'Tento týždeň',
    lastWeek: 'Minulý týždeň',
    thisMonth: 'Tento mesiac',
    lastMonth: 'Minulý mesiac',
    thisQuarter: 'Tento štvrťroku',
    lastQuarter: 'Minulý štvrťroku',
    thisYear: 'Tento rok',
    lastYear: 'Minulý rok',
    otherPeriod: 'do 1 rok',
    durationError: 'Trvanie viac ako 1 rok',
    from: 'Od',
    to: 'Do',
    powerUsageLabel: 'SPOTREBA Watt / VAr',
    recognitionTblNameCol: 'Názov',
    recognitionTblCountCol: 'Počet',
    recognitionTblWattCol: 'priama spotreba wattov',
    recognitionTblWattHoursCol: 'Watt/Hod.',
    recognitionTblPercentCol: 'Perc.',
    recognitionTblSelectedCol: 'Vybraný',
    alwaysOnTblDayCol: 'Deň',
    alwaysOnTblP1Col: 'Fáza 1',
    alwaysOnTblP2Col: 'Fáza 2',
    alwaysOnTblP3Col: 'Fáza 3',
    totalKwh: 'Spotreba kWh',
    recognitionKwh: 'Rozlíšených kWh',
    classificationKwh: 'Klasifikovaných kWh',
    alwaysOnKwh: 'Vždy zapnuté kWh',
    completeness24h: 'Prenesené údaje (posledných 24 hodín)',
    completeness1h: 'Prenesené údaje (posledných 60 minút)',
    recognitionRate: 'Miera rozpoznania zariadení',
    recognitionCorrectness: 'Miera správnosti rozpoznania',
    classificationRate: 'Miera klasifikácie',
    recognitions: 'Rozpoznania',
    recognitionsMobile: 'Využívanie energie v reálnom čase',
    alwaysOnPerDay: 'Vždy zapnuté zariadenia za deň',
    singleGraphYLabel: 'SPOTREBA / TEPLOTA',
    singleGraphUsage: 'Spotreba',
    singleGraphTemp: 'Teplota',
    singleGraphStatus: 'Stav',
    addonGraphYLabel: 'PRÉMIOVÉ DÁTA',
    kwhCost: 'Náklady na kilowatt',
    wattUnit: 'Watt',
    wUnit: 'W',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogram',
    costUnit: '€',
    var: 'VAR',
    periodPicker: 'Obdobie (do 7 dní)',
    deviceAssistant: 'Asistent zariadenia',
    meterShortName: 'Krátky názov merača (voliteľné)',
};
